import {ModalIds} from "~/types/Modals";

export type AddonInfoLocal = {
    icon: string,
    price: number | null,
    modalName: ModalIds,
    backName?: string,
    active: boolean,
    isAddon: boolean
}

export enum AddonEnumLocal {
    // SCREENSHOT_TOOL = 'screenshot_tool',
    // INVENTORY_MANAGER = 'inventory_manager',
    ADDITIONAL_API_REQUESTS = 'additional_api_requests',
    MARKET_ORDER_ANALYTICS = 'market_order_analytics',
    PRICE_RECOMMENDATIONS = 'price_recommendations',
    STEAM_ANALYTICS = 'steam_analytics',
    MIN_PRICES = 'min_prices',
    MAX_ORDERS = 'max_orders',
}

export const ADDONS: Record<AddonEnumLocal, AddonInfoLocal> = {
    // screenshot_tool: {
    //     icon: 'i-screenshot.png',
    //     price: 15000,
    // },
    // inventory_manager: {
    //     icon: 'i-inventory-manager.png',
    //     price: 15000,
    // },
    [AddonEnumLocal.ADDITIONAL_API_REQUESTS]: {
        icon: 'i-api-req.png',
        price: 15000,
        modalName: ModalIds.ADDONS_ADDITIONAL_API_REQUESTS,
        backName: "API Request",
        active: false,
        isAddon: true,
    },
    [AddonEnumLocal.MARKET_ORDER_ANALYTICS]: {
        icon: 'i-order-analytics.png',
        price: null,
        modalName: ModalIds.ADDONS_MARKET_ORDER_ANALYTICS,
        backName: "getMarketOrderAnalytics",
        active: true,
        isAddon: false,
    },
    [AddonEnumLocal.PRICE_RECOMMENDATIONS]: {
        icon: 'i-price-rec.png',
        price: null,
        modalName: ModalIds.ADDONS_PRICE_RECOMMENDATIONS,
        backName: "getPriceRecommendations",
        active: true,
        isAddon: false,
    },
    [AddonEnumLocal.STEAM_ANALYTICS]: {
        icon: 'i-steam-analytics.png',
        price: null,
        modalName: ModalIds.ADDONS_STEAM_ANALYTICS,
        backName: "getSteamAnalytics",
        active: true,
        isAddon: false,
    },
    [AddonEnumLocal.MIN_PRICES]: {
        icon: 'i-min-prices.png',
        price: null,
        modalName: ModalIds.ADDONS_MIN_PRICES,
        backName: "aggregatedMinPrices",
        active: true,
        isAddon: false,
    },
    [AddonEnumLocal.MAX_ORDERS]: {
        icon: 'i-max-orders.png',
        price: null,
        modalName: ModalIds.ADDONS_MAX_ORDERS,
        backName: "aggregatedMaxOrders",
        active: true,
        isAddon: false,
    },
}
